import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import * as d3 from 'd3';
import {getAngleFromD3Event, getBeatFromAngle, getOuterRadius} from './studioUtility';

const leftHandlerD = 'M10,0 a20,20 0 0 0 -10,10 v20 a20,20 0 0 0 10,10 v0 -40 Z';
const rightHandlerD = 'M-10,0 a20,20 0 0 1 10,10 v20 a20,20 0 0 1 -10,10 v0-40 Z';


@inject('studioStore')
@observer
class StudioPlayerTrackHandle extends Component {
    componentDidMount() {
        let svg = null;
        d3.select('#studioPlayGridSvg').each(function () {
            svg = this;
        });
        this.svg = svg;
        this.setupEvents();
    }

    setupEvents = () => {
        const drag = d3.drag()
            .on('start', () => {
                if (!this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.p, true);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onDragStart) {
                    this.props.onDragStart(angle, beat);
                }
            })
            .on('drag', () => {
                if (!this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.p, true);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onDrag) {
                    this.props.onDrag(angle, beat);
                }
            })
            .on('end', () => {
                if (!this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.p, true);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onDragEnd) {
                    this.props.onDragEnd(angle, beat);
                }
            });
        d3.select(this.p).call(drag);

        d3.select(this.p)
            .on('click', () => {
                if (!this.svg || !this.p || !this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.p, false);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onClick) {
                    this.props.onClick(angle, beat);
                }
            })
            .on('dblclick', () => {
                if (!this.svg || !this.p || !this.props.studioStore.advancedMode) {
                    return;
                }
                const angle = getAngleFromD3Event(this.svg, this.p, false);
                const beat = getBeatFromAngle(angle, this.props.beatCount);
                if (this.props.onDoubleClick) {
                    this.props.onDoubleClick(angle, beat);
                }
            });
    };

    setRef = (p) => {
        this.p = p;
    };

    render() {
        const {tier, angle, isLeft, className, hoverClassName, isHovering, onMouseOver, onMouseLeave} = this.props;
        const x = Math.sin(angle) * getOuterRadius(tier);
        const y = -Math.cos(angle) * getOuterRadius(tier);
        const leftArrowCursor = x > 3 ? 'ew-resize' : 'e-resize';
        const rightArrowCursor = x < -3 ? 'ew-resize' : 'w-resize';
        return (
            <g ref={this.setRef} className="studio-track-container">
                <path
                    d={isLeft ? leftHandlerD : rightHandlerD}
                    transform={`translate(${x},${y}) rotate(${(angle * 180) / Math.PI})`}
                    onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}
                    className={`${className} ${isLeft ? leftArrowCursor : rightArrowCursor} ${isHovering ? hoverClassName : ''}`}/>
            </g>
        );
    }

}

StudioPlayerTrackHandle.propTypes = {
    tier: PropTypes.number,
    angle: PropTypes.number,
    beatCount: PropTypes.number,
    isLeft: PropTypes.bool,
    className: PropTypes.string,
    hoverClassName: PropTypes.string,
    isHovering: PropTypes.bool,
    onDrag: PropTypes.func,
    onDragEnd: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onDoubleClick: PropTypes.func
};

export default StudioPlayerTrackHandle;
